import React, { useState } from 'react';
import { QUESTIONS, calculateType, calculateAT } from '../data/types';
import './Test.css';

export default function Test({ onComplete }) {
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers]  = useState([]);
  const [selected, setSelected] = useState(null);
  const [exiting, setExiting]   = useState(false);

  const q     = QUESTIONS[current];
  const total = QUESTIONS.length;
  const pct   = Math.round((current / total) * 100);
  const isAT  = q.dim === 'AT';

  const handleChoice = (choice) => {
    if (exiting) return;
    setSelected(choice);
    setExiting(true);
    setTimeout(() => {
      const newAnswers = [...answers, { id: q.id, dim: q.dim, choice }];
      setAnswers(newAnswers);
      setSelected(null);
      setExiting(false);
      if (current + 1 >= total) {
        const mbtiAns = newAnswers.filter(a => a.dim !== 'AT');
        const atAns   = newAnswers.filter(a => a.dim === 'AT');
        onComplete(`${calculateType(mbtiAns)}-${calculateAT(atAns)}`);
      } else {
        setCurrent(c => c + 1);
      }
    }, 280);
  };

  return (
    <div className="test">
      <div className="t-nav">
        <div className="t-logo">◈ <span>prismself</span><span className="t-dot">.com</span></div>
        <div className="t-counter">{current + 1} <span>/ {total}</span></div>
      </div>

      <div className="t-bar">
        <div className="t-bar-fill" style={{ width: `${pct}%` }} />
      </div>

      {isAT && current === 25 && (
        <div className="t-phase">✦ Final questions — Identity dimension</div>
      )}

      <main className="t-main">
        <div className={`t-card ${exiting ? 'out' : ''}`}>
          {isAT && <div className="t-dim-label">🧭 Identity Profile</div>}
          <h2 className="t-question">{q.text}</h2>
          <div className="t-choices">
            <button
              className={`t-choice ${selected === 'a' ? 'sel' : ''}`}
              onClick={() => handleChoice('a')}
            >
              <span className="t-letter">A</span>
              <span className="t-choice-text">{q.a}</span>
            </button>
            <div className="t-or">or</div>
            <button
              className={`t-choice ${selected === 'b' ? 'sel' : ''}`}
              onClick={() => handleChoice('b')}
            >
              <span className="t-letter">B</span>
              <span className="t-choice-text">{q.b}</span>
            </button>
          </div>
          <p className="t-hint">
            {isAT ? 'Choose the one that feels most natural to you.' : 'Your first instinct is usually the most accurate.'}
          </p>
        </div>
      </main>
    </div>
  );
}
